import { ShipmentLocationActionDtoLocationActionType as LocationActionType } from '@uturn/api/v1';
import type { AnyLocationAction } from '@uturn/portal/types/shipment';
import { TransportTypeCode } from '@uturn/portal/types/shipment';
import { toLocationActionType } from './locations';

/**
 * Determine transportType based on the content of locationActions.
 *
 * Import
 * - [0]  "PICKUP"
 * - [1?] "DELIVER"
 * - [-1] "DROP"
 *
 * Export
 * - [0]  "PICKUP"
 * - [1?] "LOAD"
 * - [-1] "DROP"
 *
 * Shunt
 * - [0]  "PICKUP"
 * - [-1] "DROP"
 */
export const guessTransportType = (
	locationActions: AnyLocationAction[] = [],
) => {
	const hasDelivery = locationActions.some(
		(locationAction) =>
			toLocationActionType(locationAction.locationActionType) ===
			toLocationActionType(LocationActionType.Deliver),
	);
	const hasLoad = locationActions.some(
		(locationAction) =>
			toLocationActionType(locationAction.locationActionType) ===
			toLocationActionType(LocationActionType.Load),
	);

	switch (true) {
		case locationActions.length < 3:
			return TransportTypeCode.SHUNT;
		case hasDelivery:
			return TransportTypeCode.IMPORT;
		case hasLoad:
			return TransportTypeCode.EXPORT;
		default:
			return TransportTypeCode.SHUNT;
	}
};
